import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentFinalizationTypesComponent } from './document-finalization-types.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddFinalizationComponent } from './add-finalization/add-finalization.component';
import { EditFinalizationComponent } from './edit-finalization/edit-finalization.component';

@NgModule({
    declarations: [
        DocumentFinalizationTypesComponent,
        AddFinalizationComponent,
        EditFinalizationComponent
    ],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [
        DocumentFinalizationTypesComponent
    ],
})
export class DocumentFinalizationTypesModule { }
